import React from 'react';
import Lookup from '../componentes/select-async';
import { autobind } from 'core-decorators';
import CargoEdit from '../paginas/remuneracao-variavel/cargo/edit';
import CargoView from '../paginas/remuneracao-variavel/cargo/view';

@autobind
class CargoLookup extends React.Component {
  render() {
    return (
      <Lookup
        valueKey="id"
        labelKey="nome"
        showSearch
        showNew={true}
        url="/CargoLookup"
        clearable={true}
        searchComponent={CargoView}
        editComponent={CargoEdit}
        {...this.props}
        data={{
          ...this.props.data,
          viewListSearch: true,
        }}
      />
    );
  }
}

export default CargoLookup;
